export default __webpack_public_path__ + "static/media/E-WEB-Goal-14.7e925148.png";